import { post, get } from '../utils/request';
export function contentDetail(data) {
  return post('/share/v1/content_detail', data);
}
export function relatedRec(data) {
  return post('/share/v1/related_rec', data);
}

export function getInviteUserInfo(data) {
  return get('/v1/user/get_invite_user_info', data);
}

export function chatList(data) {
  return post('/lab/v1/bullet_chat/list', {
    position: 0,
    ...data,
  });
}
